<script setup>
import BaseCell from 'dashboard/components/table/BaseCell.vue';
import Avatar from 'next/avatar/Avatar.vue';
import { useMapGetter } from 'dashboard/composables/store';

defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const isRTL = useMapGetter('accounts/isRTL');
</script>

<template>
  <BaseCell>
    <div
      class="flex items-center text-left"
      :class="{ 'flex-row-reverse': isRTL }"
    >
      <Avatar
        :src="row.original.thumbnail"
        :name="row.original.agent"
        :status="row.original.status"
        :size="32"
        hide-offline-status
        rounded-full
      />
      <div class="mx-2 my-0 flex min-w-0 flex-col items-start">
        <h6
          class="m-0 overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-[1.2] text-auth-text dark:text-auth-text-dark"
        >
          {{ row.original.agent }}
        </h6>
        <span class="text-xs text-auth-muted dark:text-auth-muted-dark">
          {{ row.original.email }}
        </span>
      </div>
    </div>
  </BaseCell>
</template>
